import { Divider, Flex, Text } from '@chakra-ui/react';
import ContributorLoadingCell from '../LoadingCell/ContributorLoadingCell';
import RowList from '../../nesting/RowList';
import { handleTeamSettingsModalProps } from '../../teamTableTypes';
import { TeamDto } from '../../types/team-table.types';

export default function Team({
  data,
  isLoading,
  handleTeamSettingsModal,
}: {
  data: TeamDto[];
  isLoading: boolean;
  handleTeamSettingsModal?: handleTeamSettingsModalProps;
}) {
  return (
    <Flex
      direction="column"
      position="sticky"
      left={8}
      bg="white"
      h={'fit-content'}
      minW="320px"
      zIndex={100}
    >
      <Flex
        bg="#FBFBFB"
        position="sticky"
        top={0}
        borderRight="1px solid #E0E0E0"
        borderLeft="1px solid #E0E0E0"
        align="center"
        minH="52px"
        px={4}
        zIndex={50}
      >
        <Flex w="full" align="center" justify={'center'}>
          <Flex w="full" gap={1} align="center">
            <Text
              fontSize="sm"
              fontFamily="heading"
              fontWeight="medium"
              color="text.secondary2"
              w="fit-content"
            >
              Team{' '}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Divider />

      {isLoading ? (
        [...Array(10)].map((_, index) => (
          <ContributorLoadingCell key={index} showXBorder />
        ))
      ) : (
        <RowList
          key="TEAM"
          colKey="TEAM"
          rows={data}
          level={0}
          handleTeamSettingsModal={handleTeamSettingsModal}
        />
      )}

      <Divider />
    </Flex>
  );
}
